module.exports = __webpack_public_path__ + "images/313a1aa.png";